import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { UnisatInjectedProvider } from '../../unisat/UnisatInjectedProvider.types';

const BITGET_BITCOIN_PROVIDER_LOCATOR = 'bitkeep.unisat';

// The Bitget provider interface is the same as Unisat provider interface
// https://docs.bitkeep.com/en/docs/guide/wallet/btc.html
export const getBitgetBitcoinInjectedProvider = () => {
  return getInjectedProviderFromWindow<UnisatInjectedProvider>(
    BITGET_BITCOIN_PROVIDER_LOCATOR
  );
};
